
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/vitally",
      function () {
        return require("private-next-pages/destinations/vitally.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/vitally"])
      });
    }
  